import {useState} from "react";
import React from "react";
import {Navbar} from "react-bulma-components";
import {useGoogleAuth} from "../GoogleContext";
import {useHistory} from "react-router";
import {useLocation} from "react-router-dom";
import logo from "./img/Logo.jpg";
import {useSelector} from "react-redux";
import {getQuickLinksData} from "../../state/selectors";
import TransactionsNav from "./TransactionsNav";
import QuickLinksNav from "./QuickLinksNav";
import {useQuickLinkData} from "../../hooks/useQuickLinkData";
import InvoiceNav from "./InvoiceNav";

function Nav() {
  const {googleUser, signOut} = useGoogleAuth();
  const {push} = useHistory();
  const location = useLocation();
  const [burgerActive, setBurgerActive] = useState(false);
  const profile = googleUser ? googleUser.profileObj : null;
  const quickLinksLoaded = useQuickLinkData({page_size: 50});
  const quickLinksData = useSelector(getQuickLinksData);

  if (!quickLinksLoaded) {
    return null;
  }

  const quickLinks = quickLinksData ? quickLinksData.results : [];

  const path = location.pathname.substring(1, location.pathname.length);

  return (
    <Navbar fixed="top" className="hide-print">
      <Navbar.Brand>
        <Navbar.Item className="navbar-item">
          <img src={logo} width="110" height="74" alt="Rentals Direct Ltd"/>
        </Navbar.Item>

        <Navbar.Burger
          className={burgerActive ? "navbar-burger is-active" : "navbar-burger"}
          onClick={() => setBurgerActive(!burgerActive)}
        />
      </Navbar.Brand>
      <Navbar.Menu
        className={burgerActive ? "navbar-menu is-active" : "navbar-menu"}
      >
        <Navbar.Container>
          <Navbar.Item
            className={path === "" ? "active-tab" : ""}
            onClick={() => {
              push("/");
              setBurgerActive(false);
            }}
          >
            Home
          </Navbar.Item>
          <Navbar.Item
            className={path.includes("job") ? "active-tab" : ""}
            onClick={() => {
              push("/jobs");
              setBurgerActive(false);
            }}
          >
            Jobs
          </Navbar.Item>
          <Navbar.Item
            className={path.includes("quote") ? "active-tab" : ""}
            onClick={() => {
              push("/quotes");
              setBurgerActive(false);
            }}
          >
            Quotes
          </Navbar.Item>
          <Navbar.Item
            className={path === "inspections" ? "active-tab" : ""}
            onClick={() => {
              push("/inspections");
              setBurgerActive(false);
            }}
          >
            Inspections
          </Navbar.Item>
          <Navbar.Item
            className={path.indexOf("part") !== -1 ? "active-tab" : ""}
            dropdown
            hoverable
          >
            <Navbar.Link>Parts</Navbar.Link>
            <Navbar.Dropdown>
              <Navbar.Item
                className={path === "partorders" ? "active-tab" : ""}
                onClick={() => {
                  push("/partorders");
                  setBurgerActive(false);
                }}
              >
                Part Orders
              </Navbar.Item>
              <Navbar.Item
                className={path === "parthistory" ? "active-tab" : ""}
                onClick={() => {
                  push("/parthistory");
                  setBurgerActive(false);
                }}
              >
                Part History
              </Navbar.Item>
              <Navbar.Item
                className={path === "partLookup" ? "active-tab" : ""}
                onClick={() => {
                  push("/partLookup");
                  setBurgerActive(false);
                }}
              >
                Part Lookups
              </Navbar.Item>
              <Navbar.Item
                className={path === "parts" ? "active-tab" : ""}
                onClick={() => {
                  push("/parts");
                  setBurgerActive(false);
                }}
              >
                Parts Expenses
              </Navbar.Item>
            </Navbar.Dropdown>
          </Navbar.Item>
          <Navbar.Item
            className={path === "workLookup" ? "active-tab" : ""}
            onClick={() => {
              push("/workLookup");
              setBurgerActive(false);
            }}
          >
            Work Lookups
          </Navbar.Item>
          <Navbar.Item
            className={(path === "invoicing" || path.includes("invoices"))  ? "active-tab" : ""}
            dropdown
            hoverable
          >
            <Navbar.Link>Invoicing</Navbar.Link>
            {profile &&
              <InvoiceNav setMenuActive={setBurgerActive} profile={profile}/>
            }
          </Navbar.Item>
          <Navbar.Item
              className={(path === "rentals" || path.includes("rentals")) ? "active-tab" : ""}
                onClick={() => {
                  push("/rentals");
                  setBurgerActive(false);
                }}
          >
                Rentals
          </Navbar.Item>
          <Navbar.Item
            className={path.includes("vehicle") || path.includes('trackers') || path.includes("keys") ? "active-tab" : ""}
            hoverable
            dropdown
          >
            <Navbar.Link>Vehicles</Navbar.Link>
            <Navbar.Dropdown>
              <Navbar.Item onClick={() => {
                push("/vehicles");
                setBurgerActive(false);
              }}>
                Vehicles
              </Navbar.Item>
              <Navbar.Item
                onClick={() => {
                  push("/keys");
                  setBurgerActive(false);
                }}
              >
                Keys
              </Navbar.Item>
              <Navbar.Item onClick={() => {
                push("/trackers");
                setBurgerActive(false);
              }}>
                Vehicle Trackers
              </Navbar.Item>
            </Navbar.Dropdown>
          </Navbar.Item>
          <Navbar.Item
            onClick={() => {
              push("/movements");
              setBurgerActive(false);
            }}
            className={path.includes("movement") ? "active-tab" : ""}
          >
            Movements
          </Navbar.Item>
          <Navbar.Item
            className={path.includes("contacts") ? "active-tab" : path.includes('accountbalance') ? 'active-tab' : ''}
            dropdown
            hoverable
          >
            <Navbar.Link>Contacts</Navbar.Link>
            <Navbar.Dropdown>
              <Navbar.Item onClick={() => {
                push("/contacts");
                setBurgerActive(false);
              }}>
                All Contacts
              </Navbar.Item>
              <Navbar.Item onClick={() => {
                push("/contacts?type=SP");
                setBurgerActive(false);
              }}>
                Suppliers
              </Navbar.Item>
              <Navbar.Item onClick={() => {
                push("/contacts?type=CC");
                setBurgerActive(false);
              }}>
                Customers
              </Navbar.Item>
              <Navbar.Item onClick={() => {
                push("/accountbalance");
                setBurgerActive(false);
              }}>
                Customer Account Balance
              </Navbar.Item>
            </Navbar.Dropdown>
          </Navbar.Item>
          <Navbar.Item
            className={path === "income" ? "active-tab" : ""}
            dropdown
            hoverable
          >
            <Navbar.Link>Income</Navbar.Link>
            {profile &&
              <TransactionsNav profile={profile} transactionType='income'
                               setMenuActive={setBurgerActive}/>
            }
          </Navbar.Item>
          <Navbar.Item
            className={path === "expenses" || path === "po" ? "active-tab" : ""}
            dropdown
            hoverable
          >
            <Navbar.Link>Expenses</Navbar.Link>
            {profile &&
              <TransactionsNav profile={profile} transactionType='expenses'
                               setMenuActive={setBurgerActive}/>
            }
          </Navbar.Item>
          <Navbar.Item
            onClick={() => {
              push("/credit");
              setBurgerActive(false);
            }}
            className={path.includes("credit") ? "active-tab" : ""}
          >
            Credit Note
          </Navbar.Item>
          <Navbar.Item
            onClick={() => {
              push("/payments");
              setBurgerActive(false);
            }}
            className={path === "payments" ? "active-tab" : ""}
          >
            Payments
          </Navbar.Item>
          {/*<Navbar.Item*/}
          {/*    className={(path === "payments" || path === "recurringpayments")  ? "active-tab" : ""}*/}
          {/*    dropdown*/}
          {/*    hoverable*/}
          {/*>*/}
          {/*  <Navbar.Link>Sale Payments</Navbar.Link>*/}
          {/*  <Navbar.Dropdown>*/}
          {/*    <Navbar.Item*/}
          {/*        className={path === "payments" ? "active-tab" : ""}*/}
          {/*        onClick={() => {*/}
          {/*          push("/payments");*/}
          {/*          setBurgerActive(false);*/}
          {/*        }*/}
          {/*      }*/}
          {/*    >*/}
          {/*      Payments*/}
          {/*    </Navbar.Item>*/}
          {/*    <Navbar.Item*/}
          {/*        className={path === "recurringpayments" ? "active-tab" : ""}*/}
          {/*        onClick={() => {*/}
          {/*            push("/recurringpayments");*/}
          {/*            setBurgerActive(false);*/}
          {/*          }*/}
          {/*        }*/}
          {/*    >*/}
          {/*      Recurring Payments*/}
          {/*    </Navbar.Item>*/}
          {/*  </Navbar.Dropdown>*/}
          {/*</Navbar.Item>*/}
          <Navbar.Item
            className={path === "diary" ? "active-tab" : ""}
            onClick={() => {
              push("/diary");
              setBurgerActive(false);
            }}
          >
            Diary
          </Navbar.Item>
          <Navbar.Item
            className={path === "reports" ? "active-tab" : ""}
            onClick={() => {
              push("/reports");
              setBurgerActive(false);
            }}
          >
            Reports
          </Navbar.Item>
          <Navbar.Item
            className={path === "quicklinks" ? "active-tab" : ""}
            dropdown
            hoverable
          >
            <Navbar.Link>Quick Links</Navbar.Link>
            <QuickLinksNav quickLinks={quickLinks}/>
          </Navbar.Item>
          <Navbar.Item
            className={path === "alllinks" ? "active-tab" : ""}
            onClick={() => {
              push("/alllinks");
              setBurgerActive(false);
            }}
          >
            Links
          </Navbar.Item>
          <Navbar.Item
            className={path === "settings" ? "active-tab" : ""}
            onClick={() => {
              push("/settings");
              setBurgerActive(false);
            }}
          >
            Settings
          </Navbar.Item>
        </Navbar.Container>
        <Navbar.Container position="end">
          {profile && <Navbar.Item>{profile.givenName}</Navbar.Item>}
          <Navbar.Item
            onClick={() => {
              signOut();
              localStorage.clear();
              window.location.href = "/login";
            }}
          >
            Log out
          </Navbar.Item>
        </Navbar.Container>
      </Navbar.Menu>
    </Navbar>
  );
  // }
}

export default Nav;
